module.exports = __webpack_public_path__ + "assets/facebookIcon-09ac1e.svg";